import React, { useState } from 'react';
import { SparklesIcon } from 'lucide-react';
import { genreColors, formatIcons } from './constants';
import { BookHoverCard } from './BookHoverCard';
import { SectionHeader, VendorBookInfoModal, CoverCarousel } from './BookDisplay';
export const AllBooksView = ({
  organizationMode,
  viewMode,
  darkMode,
  bookShelves,
  sortedBooks,
  booksByType,
  booksPerShelf,
  hoveredBookId,
  setHoveredBookId,
  mousePosition,
  navigateToBookEdit
}: any) => {
  const [selectedBook, setSelectedBook] = useState<any | null>(null);
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const handleSpineTap = (book: any) => {
    if (window.innerWidth < 768) {
      setSelectedBook(book);
    } else {
      navigateToBookEdit(book.id);
    }
  };
  const SpineBook = ({
    book
  }: {
    book: any;
  }) => <div onClick={() => handleSpineTap(book)} onMouseEnter={() => !isMobile && setHoveredBookId(book.id)} onMouseLeave={() => setHoveredBookId(null)} className="relative flex flex-col items-center justify-center text-white font-medium rounded transition-transform duration-200 ease-in-out cursor-pointer text-center hover:scale-105 select-none flex-shrink-0" style={{
    width: book.edition === 'special' ? 68 : 56,
    height: book.edition === 'special' ? 250 : 220,
    fontSize: book.edition === 'special' ? '1rem' : '0.85rem',
    backgroundColor: genreColors[!book.coverImage ? book.genre : ''] || genreColors.default,
    backgroundImage: book.coverImage ? `url(${book.coverImage})` : undefined,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    marginBottom: 4
  }} title={book.title} data-id="element-17909" data-mp="ren0n4dyn3m1">
      {!book.coverImage && <div className="flex flex-col items-center px-1 w-full h-full justify-center" style={{
      writingMode: 'vertical-rl'
    }} data-id="element-17910" data-mp="310r6gjjzbhe0">
          <div className="w-full truncate" data-id="element-17911" data-mp="15x2paa9yuw9h">{book.title}</div>
          {book.seriesNumber && <div className="mt-2 text-xs font-normal opacity-80" data-id="element-17912" data-mp="10xzudinpa6f8">
              #{book.seriesNumber}
            </div>}
        </div>}
      <div className="absolute bottom-1 left-1 inline-flex items-center justify-center p-1 rounded bg-black bg-opacity-70 text-white text-xs z-10" title={book.format} data-id="element-17913" data-mp="1fnntqecbmv0b">
        {formatIcons[book.format]}
      </div>
      {book.edition === 'special' && <div className="absolute top-1 right-1 inline-flex items-center justify-center p-1 rounded-full bg-purple-600 bg-opacity-90 text-white text-xs z-10" data-id="element-17914" data-mp="1kmqn31ixvcsg">
          <SparklesIcon className="h-3 w-3" data-id="element-17915" data-mp="1yjdxa5zwjzgb" />
        </div>}
    </div>;
  // Standard cover grid (for mixed/unordered groups)
  const CoverGrid = ({
    books
  }: {
    books: any[];
  }) => <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-6" data-id="element-17916" data-mp="49tj4cw9wfrz">
      {books.map((book: any) => <div key={book.id} className="relative flex flex-col items-center cursor-pointer group" onClick={() => setSelectedBook(book)} onMouseEnter={() => !isMobile && setHoveredBookId(book.id)} onMouseLeave={() => setHoveredBookId(null)} data-id="element-17917" data-mp="2avg0vt693o37">
          <div className="relative w-full" data-id="element-17918" data-mp="264r9edukmr42">
            <div className="w-full aspect-[2/3] bg-center bg-cover rounded-lg shadow-md transition-transform duration-200 ease-in-out group-hover:scale-[1.03] group-hover:shadow-xl" style={{
          backgroundImage: `url('${book.coverImage}')`
        }} title={book.title} data-id="element-17919" data-mp="263okgbgt6yqs" />
          </div>
        </div>)}
    </div>;
  return <>
      {organizationMode === 'all' ? viewMode === 'spine' ? bookShelves.map((shelf: any, shelfIndex: any) => <div key={`shelf-${shelfIndex}`} className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow-md p-6 mb-8`} data-id="element-17920" data-mp="3hky2ctkahipz" data-mpi={shelfIndex}>
              {shelfIndex === 0 && <h2 className={`text-xl font-semibold mb-6 ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-17921" data-mp="1dgblge6vfc8o">
                  My Books
                </h2>}
              <div className="relative" data-id="element-17922" data-mp="13j70ghorhmtg">
                <div className="flex items-end gap-2 overflow-x-auto pb-6 scrollbar-thin" style={{
          minHeight: 260
        }} data-id="element-17923" data-mp="13ki1wauqiihe">
                  {shelf.map((book: any) => <SpineBook key={book.id} book={book} data-id="element-17924" data-mp="ps26nw82ror1" />)}
                  <div className={`absolute bottom-0 left-0 right-0 h-2 ${darkMode ? 'bg-purple-900' : 'bg-purple-600'} rounded-full`} data-id="element-17925" data-mp="ksfrviclm0g4" />
                </div>
              </div>
              {!isMobile && hoveredBookId && (() => {
        const hoveredBook = shelf.find((book: any) => book.id === hoveredBookId);
        return hoveredBook ? <BookHoverCard book={hoveredBook} darkMode={darkMode} mousePosition={mousePosition} data-id="element-17926" data-mp="anzdkteroref" /> : null;
      })()}
            </div>) : <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow-md p-6 mb-8`} data-id="element-17927" data-mp="3e2lambxlff8z">
            <h2 className={`text-xl font-semibold mb-6 ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-17928" data-mp="3o2vq6373oyrb">
              My Books
            </h2>
            <CoverGrid books={sortedBooks} data-id="element-17929" data-mp="3sux03igsqde6" />
          </div> : <>
          {booksByType.series.length > 0 && <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow-md p-6 mb-8`} data-id="element-17930" data-mp="30crlrtm38uz9">
              <SectionHeader title="My Series" darkMode={darkMode} data-id="element-17931" data-mp="2sbai37lg5vtg" />
              {viewMode === 'spine' ? <div className="relative" data-id="element-17932" data-mp="2ncz7gunbvha6">
                  <div className="flex items-end gap-2 overflow-x-auto pb-6 scrollbar-thin" style={{
            minHeight: 260
          }} data-id="element-17933" data-mp="322etxyftt0k2">
                    {booksByType.series.slice(0, booksPerShelf).map((book: any) => <SpineBook key={book.id} book={book} data-id="element-17934" data-mp="24g7kaa4o0i0u" />)}
                    <div className={`absolute bottom-0 left-0 right-0 h-2 ${darkMode ? 'bg-purple-900' : 'bg-purple-600'} rounded-full`} data-id="element-17935" data-mp="2jcoq6lu354g0" />
                  </div>
                </div> : <CoverGrid books={booksByType.series.slice(0, booksPerShelf)} data-id="element-17936" data-mp="3przhkumxclzo" />}
            </div>}

          {booksByType.standalone.length > 0 && <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow-md p-6 mb-8`} data-id="element-17937" data-mp="14t2ehr3hoxo">
              <SectionHeader title="Standalone Books" darkMode={darkMode} data-id="element-17938" data-mp="3oatv4ukubn6z" />
              {viewMode === 'spine' ? <div className="relative" data-id="element-17939" data-mp="3sbvwbgybi9bl">
                  <div className="flex items-end gap-2 overflow-x-auto pb-6 scrollbar-thin" style={{
            minHeight: 260
          }} data-id="element-17940" data-mp="3scp50ngu78wd">
                    {booksByType.standalone.slice(0, booksPerShelf).map((book: any) => <SpineBook key={book.id} book={book} data-id="element-17941" data-mp="f53t9ksen3iu" />)}
                    <div className={`absolute bottom-0 left-0 right-0 h-2 ${darkMode ? 'bg-purple-900' : 'bg-purple-600'} rounded-full`} data-id="element-17942" data-mp="12uy6i3gmyu3m" />
                  </div>
                </div> : <CoverGrid books={booksByType.standalone.slice(0, booksPerShelf)} data-id="element-17943" data-mp="ix3jzhuajtuf" />}
            </div>}

          {booksByType.anthology.length > 0 && <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow-md p-6 mb-8`} data-id="element-17944" data-mp="93mnu76om2nl">
              <SectionHeader title="Anthology Contributions" darkMode={darkMode} data-id="element-17945" data-mp="11u4m8uwgnfuo" />
              {viewMode === 'spine' ? <div className="relative" data-id="element-17946" data-mp="wt8iqig0tvps">
                  <div className="flex items-end gap-2 overflow-x-auto pb-6 scrollbar-thin" style={{
            minHeight: 260
          }} data-id="element-17947" data-mp="rvfgu1lr3nvb">
                    {booksByType.anthology.slice(0, booksPerShelf).map((book: any) => <SpineBook key={book.id} book={book} data-id="element-17948" data-mp="37ppizq06njt6" />)}
                    <div className={`absolute bottom-0 left-0 right-0 h-2 ${darkMode ? 'bg-purple-900' : 'bg-purple-600'} rounded-full`} data-id="element-17949" data-mp="1n7555wip6yfg" />
                  </div>
                </div> : <CoverGrid books={booksByType.anthology.slice(0, booksPerShelf)} data-id="element-17950" data-mp="21uqbs0es7fs4" />}
            </div>}

          {/* Special Editions — carousel (ordered/curated group) */}
          {booksByType.specialEditions.length > 0 && <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow-md p-6 mb-8`} data-id="element-17951" data-mp="2fu97ftqeoynj">
              <SectionHeader title="Special Editions" darkMode={darkMode} data-id="element-17952" data-mp="2ks19vhoog35z" />
              {viewMode === 'spine' ? <div className="relative" data-id="element-17953" data-mp="lhjdjc01fpg5">
                  <div className="flex items-end gap-2 overflow-x-auto pb-6 scrollbar-thin" style={{
            minHeight: 260
          }} data-id="element-17954" data-mp="qet9lahxmzcy">
                    {booksByType.specialEditions.slice(0, booksPerShelf).map((book: any) => <SpineBook key={book.id} book={book} data-id="element-17955" data-mp="h98imrpsvvpd" />)}
                    <div className={`absolute bottom-0 left-0 right-0 h-2 ${darkMode ? 'bg-purple-900' : 'bg-purple-600'} rounded-full`} data-id="element-17956" data-mp="ldoj2dgnaax7" />
                  </div>
                </div> : <CoverCarousel books={booksByType.specialEditions.slice(0, booksPerShelf)} darkMode={darkMode} onBookClick={book => setSelectedBook(book)} onHoverEnter={id => !isMobile && setHoveredBookId(id)} onHoverLeave={() => setHoveredBookId(null)} data-id="element-17957" data-mp="1019mk8hfmc5n" />}
            </div>}
        </>}

      {selectedBook && <VendorBookInfoModal book={selectedBook} darkMode={darkMode} onClose={() => setSelectedBook(null)} onEdit={navigateToBookEdit} data-id="element-17958" data-mp="2ykee4jpz6360" />}
    </>;
};